import {Component, Inject, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../security/jwtUtil.service";

@Component({
    "selector": "prm-libraries-around-bar",
    templateUrl: 'components/search/fullView/ngrs/librariesAroundBar/librariesAroundBar.html'
})

export class PrmLibrariesAroundBar{
    constructor (){       
    }

    ngOnInit(){
    }

 

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/librariesAroundBar/librariesAroundBar.directive.ts